/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'navigation';
const componentName = 'administration-vertical-nav';
const prefix = `${moduleName}.${componentName}`;

export const accountsLabel = `${prefix}.accountsLabel`;
export const usersLabel = `${prefix}.usersLabel`;
export const userProfilesLabel = `${prefix}.userProfilesLabel`;
export const tenantsLabel = `${prefix}.tenantsLabel`;
export const systemSettingsLabel = `${prefix}.systemSettingsLabel`;
export const cloudServicesLabel = `${prefix}.cloudServicesLabel`;
export const licensingLabel = `${prefix}.licensingLabel`;
export const nodesLabel = `${prefix}.nodesLabel`;
export const softwareLabel = `${prefix}.softwareLabel`;
export const updateLabel = `${prefix}.updateLabel`;
export const uploadHsmPackagesLabel = `${prefix}.uploadHsmPackagesLabel`;
export const configurationBackupLabel = `${prefix}.configurationBackupLabel`;
export const userCredentialsLabel = `${prefix}.userCredentialsLabel`;
export const supportLabel = `${prefix}.supportLabel`;
export const techSupportLabel = `${prefix}.techSupportLabel`;
export const crashReportsLabel = `${prefix}.crashReportsLabel`;
export const externalServicesLabel = `${prefix}.externalServicesLabel`;
export const reportsLabel = `${prefix}.reportsLabel`;

export const ENGLISH = {
    [accountsLabel]: 'Accounts',
    [usersLabel]: 'Users',
    [userProfilesLabel]: 'User Profiles',
    [tenantsLabel]: 'Tenants',
    [systemSettingsLabel]: 'System Settings',
    [cloudServicesLabel]: 'Cloud Services',
    [licensingLabel]: 'Licensing',
    [nodesLabel]: 'Nodes',
    [softwareLabel]: 'Software',
    [updateLabel]: 'Update',
    [uploadHsmPackagesLabel]: 'Upload HSM Packages',
    [configurationBackupLabel]: 'Configuration Backup',
    [userCredentialsLabel]: 'User Credentials',
    [supportLabel]: 'Support',
    [techSupportLabel]: 'Tech Support',
    [crashReportsLabel]: 'Crash Reports',
    [externalServicesLabel]: 'External Services',
    [reportsLabel]: 'Reports',
};
